import { css } from '@emotion/react';

import useTheme from '../../hooks/useTheme';

export default () => {
  const { breakpoints, colors, spacing } = useTheme();

  return {
    base: css`
      height: 100%;
    `,
    header: css`
      margin-bottom: 2.5rem;
    `,
    middle: css``,
    filterButtonWrapper: css`
      display: flex;
      justify-content: flex-end;

      // this is to make sure on really small
      // screens the title and button dont overlap
      @media screen and (min-width: 340px) {
        margin-bottom: -1.5rem;
      }
    `,
    button: css`
      border: 1px solid ${colors.blue};
      width: auto;
      background: none;
      color: ${colors.blue};
      text-transform: uppercase;

      &:not([disabled]):hover {
        border-color: ${colors.blue};
        background: ${colors.blue};
        color: ${colors.white};
      }

      &:focus {
        border-color: ${colors.blue};
        background: ${colors.white};
        color: ${colors.black};
        text-decoration: underline;
      }
    `,
    title: isClubInfo => css`
      display: inline-block;
      font-size: 1.62rem;
      color: ${colors.navy};
      font-style: normal;
      font-family: 'FS Dillon Bold' !important;

      ${!isClubInfo &&
      css`
        margin: ${spacing.s} 0;
      `}
      margin-bottom: ${spacing.xs};

      ${breakpoints.m} {
        font-size: 1.62rem;
        font-style: normal;
        letter-spacing: 0px;
      }
      ${breakpoints.l} {
        font-family: 'FS Dillon';
        font-style: normal;
        font-size: 35.54px;
      }
    `,
    genderHeader: css`
      grid-gap: 8px;
      display: flex;
      margin: 5px 0 10px;

      .Male {
        width: 77px;
      }

      .Female {
        width: 89px;
      }

      .Mixed {
        width: 80px;
      }
    `,
    gender: isSelected => css`
      display: flex;
      align-items: center;
      border-radius: 20px;
      height: 36px;
      font-size: 14px;
      text-align: center;
      color: ${colors.gender_grey};
      border: 2px solid #bbc1ce;
      justify-content: center;
      cursor: pointer;

      ${isSelected &&
      css`
        color: ${colors.white};
        background-color: ${colors.blue};
        border: 2px solid ${colors.blue};
      `}

      @media (hover: hover) and (pointer: fine) {
        &:hover {
          background-color: ${colors.navy};
          color: ${colors.white};
          border: 2px solid ${colors.navy};
        }
      }
      
      ${breakpoints.s} {
        &:focus-visible {
          border: 2px solid ${colors.border_black}; 
          outline: 2px solid ${colors.skip_yellow};
        }
      }
    `,

    subtitle: css`
      display: block;
      color: ${colors.navy};
      margin-top: 9px;
      margin-bottom: -1.8rem;
      display: grid;
      grid-template-columns: 9% auto;
      align-items: center;
      ${breakpoints.l} {
        grid-template-columns: 6% auto;
      }
      @media (min-device-width: 601px) and (max-device-width: 769px) {
        grid-template-columns: 6% auto;
      }
      @media (min-device-width: 501px) and (max-device-width: 600px) {
        grid-template-columns: 6% auto;
      }
      @media (min-device-width: 420px) and (max-device-width: 500px) {
        grid-template-columns: 8% auto;
      }
    `,
    check: css`
      appearance: none;
      height: 18px;
      width: 18px;
      border: 2px solid ${colors.checkGrey};
      border-radius: 4px;
      cursor: pointer;
      display: flex;
      align-items: center;
      justify-content: center;
      position: relative;
      transition: border 0.2s ease-in-out;
      outilne: none;

      &:hover {
        border: 2px solid ${colors.checkNavy};
      }

      &:checked {
        border-color: ${colors.placeholder_black};
        background-color: white;
      }

      &::after {
        content: '';
        width: 3px;
        height: 8px;
        border: solid transparent;
        border-width: 0 2px 2px 0;
        transform: rotate(45deg);
        position: absolute;
        transform: translate(-9%, -13%) rotate(45deg);
        display: none;
      }

      &:checked::after {
        border-color: #041c39;
        display: block;
      }

      &:checked {
        &:hover {
          border: 2px solid ${colors.checkNavy};
        }
      }
      
      ${breakpoints.s} {
        &:focus-visible {
          border: 2px solid ${colors.border_black}; 
          outline: none;
          box-shadow: 0 0 0 2px ${colors.skip_yellow}; 
        }
      }
    `,
    animateSession: css`
      opacity: 0;
      animation: fade_in_show 1.5s ease-in-out 0s forwards;

      &:nth-of-type(even) {
        h3 {
          background-color: white;
        }
      }

      &:last-child {
        h3 {
          border-bottom: 0;
        }
      }

      @keyframes fade_in_show {
        from {
          opacity: 0;
          transform: translate3d(0, 40%, 0);
        }

        to {
          opacity: 1;
          transform: none;
        }
      }
    `,
  };
};
